import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

export default function FAQ() {
  const { t } = useLanguage();
  return (
    <section id="insights" data-testid="faq-section" className="bg-slate-50 py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">{t.faq.overline}</p>
            <h2 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-slate-950">
              {t.faq.title}
            </h2>
          </Reveal>
          <Reveal className="md:col-span-8" delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-start font-outfit text-base md:text-lg font-medium text-slate-950 hover:text-brand-700 hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm md:text-base text-slate-600 leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
